import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import emptyStateImage from 'assets/img/icn-empty-state.svg';
import * as actions from '../action';
import * as c from '../constant';

function PurposesContent({
  handleAddModal,
  handleEdit,
  handleRemove,
  purposeId,
  showPurpose,
  purposeInfo,
  activatePurpose,
  deActivatePurpose,
  isLoading,
}) {
  useEffect(() => {
    if (_.isEmpty(purposeId)) return;
    showPurpose(purposeId);
  }, [purposeId]);

  const handleToggleActive = () => {
    if (_.get(purposeInfo, 'attributes.is_active')) {
      deActivatePurpose(purposeId, {}, () => showPurpose(purposeId));
    } else {
      activatePurpose(purposeId, {}, () => showPurpose(purposeId));
    }
  };
  return (
    <div className="container-fluid position-relative">
      {isLoading && (
        <div
          style={{
            position: 'absolute',
            left: 0,
            top: 0,
            width: '100%',
            height: '100%',
            zIndex: 9999,
            backgroundColor: 'rgba(0,0,0,0.2)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            color: 'white',
            fontSize: '1.5rem',
            fontWeight: 'bold',
          }}
        >
          Loading...
        </div>
      )}

      <div className='card'>
        <div className='card-body'>
          <div className='ml-auto'>
            <button
              type="button"
              onClick={handleAddModal}
              className="btn btn-success text-dark btn-sm d-flex align-items-center justify-content-center ml-auto"
            >
              <i className="fas fa-plus mr-1" />
              Add
            </button>
          </div>

          {!_.isEmpty(purposeInfo) ? (
            <React.Fragment>
              <div className='d-flex align-items-center mt-3'>
                <h2 className='font-weight-bold m-0'>
                  {_.get(purposeInfo, 'attributes.name') || '--'}
                </h2>
                <button
                  type="button"
                  className="btn btn-sm btn-primary ml-auto"
                  onClick={handleEdit(purposeInfo)}
                >
                  Edit
                </button>
                <button
                  type="button"
                  className="btn btn-sm btn-danger ml-1 d-none" // DELETE ICON IS HIDDEN BECAUSE THERE'S NO DELETE PURPOSE
                  onClick={handleRemove(purposeInfo)}
                >
                  Delete
                </button>
              </div>
              <div className='p-3 border rounded mt-3 table-responsive'>
                <div className="custom-control custom-switch text-right">
                  <input
                    type="checkbox"
                    className="custom-control-input"
                    id="isActive"
                    name="is_active"
                    checked={_.get(purposeInfo, 'attributes.is_active')}
                    onChange={handleToggleActive}
                  />
                  <label
                    style={{ fontSize: '.9rem' }}
                    className="custom-control-label mt-2"
                    htmlFor="isActive"
                  >
                    Is Active?
                  </label>
                </div>
                <table className="transaction-table table table-borderless table-sm">
                  <tbody>
                    <tr>
                      <td className="text-dark" width="250">
                        Title
                      </td>
                      <td className="text-dark" width="1">
                        :
                      </td>
                      <td colSpan={4}>
                        <b>{_.get(purposeInfo, 'attributes.name') || '--'}</b>
                      </td>
                    </tr>
                    <tr>
                      <td className="text-dark" width="250">
                        Is Country Code Required
                      </td>
                      <td className="text-dark" width="1">
                        :
                      </td>
                      <td colSpan={4}>
                        <b>
                          {_.get(
                            purposeInfo,
                            'attributes.with_country_code'
                          ) ? 'Yes' : 'No'}
                        </b>
                      </td>
                    </tr>
                    {/* <tr>
                      <td className="text-dark" width="250">
                        For Birth Certificate
                      </td>
                      <td className="text-dark" width="1">
                        :
                      </td>
                      <td colSpan={4}>
                        <b>
                          {_.get(
                            purposeInfo,
                            'attributes.for_birth_certificate'
                          ) ? 'Yes' : 'No'}
                        </b>
                      </td>
                    </tr>
                    <tr>
                      <td className="text-dark" width="250">
                        For Death Certificate
                      </td>
                      <td className="text-dark" width="1">
                        :
                      </td>
                      <td colSpan={4}>
                        <b>
                          {_.get(
                            purposeInfo,
                            'attributes.for_death_certificate'
                          ) ? 'Yes' : 'No'}
                        </b>
                      </td>
                    </tr>
                    <tr>
                      <td className="text-dark" width="250">
                        For Marriage Certificate
                      </td>
                      <td className="text-dark" width="1">
                        :
                      </td>
                      <td colSpan={4}>
                        <b>
                          {_.get(
                            purposeInfo,
                            'attributes.for_marriage_certificate'
                          ) ? 'Yes' : 'No'}
                        </b>
                      </td>
                    </tr> */}
                  </tbody>
                </table>
              </div>
            </React.Fragment>
          ) : (
            <div className="d-flex align-items-center justitfy-content-center h-100">
              <div className="text-center mx-auto py-4">
                <img
                  src={emptyStateImage}
                  className="img-responsive image-wrapper mb-4 mt-3"
                  alt="Empty State"
                />
                <p className="emp-title mb-0"> No Item Found </p>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

PurposesContent.propTypes = {
  handleAddModal: PropTypes.instanceOf(Function).isRequired,
  handleEdit: PropTypes.instanceOf(Function).isRequired,
  handleRemove: PropTypes.instanceOf(Function).isRequired,

  showPurpose: PropTypes.instanceOf(Function).isRequired,
  purposeInfo: PropTypes.instanceOf(Object).isRequired,
  purposeId: PropTypes.string.isRequired,
  activatePurpose: PropTypes.instanceOf(Function).isRequired,
  deActivatePurpose: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }, { match }) => ({
  purposeInfo: _.get(api, `${c.GET_SINGLE_PURPOSE}.item`) || {},
  purposeId: _.get(match, 'params.purposeId') || '',
  isLoading: api.loading.indexOf(c.GET_SINGLE_PURPOSE) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(PurposesContent);
